import PropTypes from 'prop-types';
import { useSnackbar } from "notistack";
import { makeStyles } from '@material-ui/core/styles';
import React, { useState, useEffect, useRef } from "react";
import { Button, DialogActions, DialogContent } from "@material-ui/core";

import BasicInfo from './BasicInfo.js';
import CreatedBy from './CreatedBy.js';
import Usinas from './Usinas.js';
import api from "../../../../../services/api.js";

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            width: '25ch',
        },
    },
}));

export default function FormStore(props) {
    const classes = useStyles();

    const snack = useRef()
    const { enqueueSnackbar } = useSnackbar();
    snack.current = enqueueSnackbar

    const [values, setValues] = useState({
        termos: '',
        acao: '',
        status: 'local',

        criado_em: '',
        criado_por: '',
        editado_em: '',
        editado_por: '',
    });

    const [usinas, setUsinas] = React.useState({
    });

    useEffect(() => {
        //quando fornecedor já existe (carrega usinas - checkbox)
        if (props.data) {
            let checked = {}
            for (let usina of props.list_usinas) {
                checked[usina._id] = false
            }
            for (let usina of props.data.usinas) {
                checked[usina] = true
            }
            setUsinas(checked);
            setValues(props.data)
            setUpdate(true)
        }
        //inserir novo fornecedor (usina checkbox)
        else {
            let checked = {}
            for (let usina of props.list_usinas) {
                checked[usina._id] = false
            }
            setUsinas(checked)
        }
    }, [props])

    const [update, setUpdate] = useState(false) // true in edit mode
    useEffect(() => {
        if (props.data) {
            setValues(props.data)
            setUpdate(true)
        }
    }, [props])


    async function AddNew() {
        snack.current("adicionado, aguarde.", { variant: 'info' })
        let my_usinas = []
        for (let key in usinas) {
            if (usinas[key]) {
                my_usinas.push(key)
            }
        }
        var new_epae = {
            "termos": values.termos,
            "acao": values.acao,
            "status": values.status,
            "usinas": my_usinas,
        }
        api.post(`/epae`, { new_epae })
            .then(() => {
                props.setReload(currentIsOpen => !currentIsOpen)
                props.setOpen(false)
                snack.current(`ePAE criado`, { variant: 'success' })
            })
            .catch((error) => {
                if (error.response.data.message) {
                    snack.current(`${error.response.data.message}`, { variant: 'error' })
                } else {
                    snack.current("Falha ao adicionar ePAE!", { variant: 'error' })
                }
            });
    }

    async function Update() {
        snack.current("editando, aguarde.", { variant: 'info' })
        let my_usinas = []
        for (let key in usinas) {
            if (usinas[key]) {
                my_usinas.push(key)
            }
        }
        var update_epae = {
            "_id": values._id,
            "termos": values.termos,
            "acao": values.acao,
            "status": values.status,
            "usinas": my_usinas,
        }
        api.put(`/epae`, { update_epae })
            .then(() => {
                props.setReload(currentIsOpen => !currentIsOpen)
                props.setOpen(false)
                snack.current("ePAE editado!", { variant: 'success' })
            })
            .catch((error) => {
                if (error.response.data.message) {
                    snack.current(`${error.response.data.message}`, { variant: 'error' })
                } else {
                    snack.current("Falha ao adicionar ePAE!", { variant: 'error' })
                }
            });
    }

    return (
        <>
            <DialogContent className={classes.root}>
                <div className="titles">Informações Gerais</div>
                <div className="row">
                    <div style={{ width: '80%' }}>
                        <BasicInfo values={values} setValues={setValues} update={update} />
                    </div>
                    <div style={{ width: '30%' }}>
                        <Usinas update={update} usinas={usinas} setUsinas={setUsinas} list_usinas={props.list_usinas} />
                    </div>
                </div>
                <CreatedBy values={values} setValues={setValues} />
            </DialogContent >
            <DialogActions>
                <Button
                    onClick={() => { update === true ? Update() : AddNew() }}
                >
                    Salvar
                </Button>
                <Button onClick={() => { props.setOpen(false) }}>
                    Cancelar
                </Button>
            </DialogActions>
        </>
    )
}

FormStore.propTypes = {
    setOpen: PropTypes.func,
    setReload: PropTypes.func
};
